/* Product-card "Notify" button (sold-out products; see snippets/card-product.liquid).
   Opens the same Restock Rocket sign-up modal as the product page's "Notify me when available".
   The app exposes window._RestockRocket.openModal(product, variantId); it wants the product's
   storefront JSON, which is what /products/<handle>.js returns. If the app isn't loaded on this
   page, fall back to the product page, where its own button is. */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-lr-card-notify]');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();

  const { productHandle, variantId, productUrl } = button.dataset;
  const openModal = window._RestockRocket && window._RestockRocket.openModal;
  if (!openModal) {
    window.location.href = productUrl;
    return;
  }

  if (button.getAttribute('aria-disabled') === 'true') return;
  button.setAttribute('aria-disabled', 'true');
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${productHandle}.js`);
    if (!response.ok) throw new Error(`Product fetch failed: ${response.status}`);
    const product = await response.json();
    openModal(product, Number(variantId));
  } catch (error) {
    console.error(error);
    window.location.href = productUrl;
  } finally {
    button.removeAttribute('aria-disabled');
  }
});
